import { IPreloaderState } from './types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: IPreloaderState = {
  isShow: false,
  requestsQty: 0
}

const transparentPreloaderSlice = createSlice({
  name: 'transparentPreloader',
  initialState,
  reducers: {
    showTransparentPreloaderAction: (state) => {
      state.isShow = true
      state.requestsQty = ++state.requestsQty
    },
    hideTransparentPreloaderAction: (state) => {
      state.requestsQty = --state.requestsQty
      if (!state.requestsQty) {
        state.isShow = false
      }
    }
  }
})

export const { showTransparentPreloaderAction, hideTransparentPreloaderAction } =
  transparentPreloaderSlice.actions
export default transparentPreloaderSlice.reducer
